import CreateReport from './CreateReport';
import React from 'react';

const CreateAIReport = (props: any) => {
  return <CreateReport {...props} aiReport={true} />;
};

export default CreateAIReport;
